module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0064.jpg?v=fb5f4f12";